import classNames from 'classnames';
import React from 'react';
import { connect } from 'react-redux';

import { getSelectedProjectId } from '../../redux/projects/projects.selectors';
import { StoreState } from '../../redux/reducers/store.types';
import { getSelectedOrganizationId } from '../../selectors/organizations/organizations';
import { MaybeNull } from '../../types/system';
import { navigation } from '../../utils';
import { compilePath } from '../../utils/navigation';

import styles from './link.scss';

export type LinkTheme = 'blue' | 'blueonhover' | 'custom';

interface OwnProps {
  dataHook?: string;
  path: string;
  queryParams?: {};
  organizationId?: string;
  projectId?: string;
  className?: string;
  children: React.ReactNode;
  blank?: boolean;
  onClick?(): void;
  theme?: LinkTheme;
  linkRef?(ref: MaybeNull<HTMLAnchorElement>): void;
}

interface StateProps {
  organizationId: string;
  projectId?: string;
}

type Props = OwnProps & StateProps;

class LinkComponent extends React.Component<Props> {
  private getPathParams() {
    const { organizationId, projectId } = this.props;

    return {
      organizationId,
      projectId,
    };
  }

  public getCompiledPath(): string {
    const { path, queryParams } = this.props;

    return compilePath(path, this.getPathParams(), queryParams);
  }

  public onClick(event) {
    const { path, blank, onClick, queryParams } = this.props;

    event.preventDefault();

    if (event.metaKey || event.ctrlKey || blank) {
      window.open(this.getCompiledPath(), '_blank');
    } else {
      navigation.goToPath(path, this.getPathParams(), queryParams);
    }

    onClick && onClick();
  }

  private getStyleForTheme() {
    switch (this.props.theme) {
      case 'blueonhover':
        return styles.blueonhoverTheme;
      case 'blue':
        return styles.blueTheme;
      case 'custom':
      default:
        return null;
    }
  }

  public render() {
    const { children, className, dataHook, linkRef } = this.props;
    const topClassNames = classNames(
      styles.wrapper,
      this.getStyleForTheme(),
      className,
    );

    return (
      <a
        className={topClassNames}
        data-hook={dataHook}
        ref={linkRef}
        href={this.getCompiledPath()}
        onClick={this.onClick.bind(this)}
      >
        {children}
      </a>
    );
  }
}

const mapStateToProps = (state: StoreState, ownProps: Props): StateProps => ({
  organizationId: ownProps.organizationId || getSelectedOrganizationId(state),
  projectId: ownProps.projectId || getSelectedProjectId(state),
});

export const Link = connect<StateProps, null, OwnProps>(mapStateToProps)(
  LinkComponent,
);
